import { LocationItem } from '../Card';
import React from 'react';

import { AccommodationItemsFragment } from '../../generated/graphql';
import { accommodationItemRoute } from '../../helpers/routes';
import { PageItemLink } from '../PageItemLink';
import { ItemProps } from './common';
import { resizeImageW } from '../../helpers/mediaApiUrls';

const Accommodation: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const accom = item as AccommodationItemsFragment;
  const photoPath = resizeImageW(accom.photo?.mediaUrl, 145);

  return (
    <PageItemLink
      to={accommodationItemRoute(page.id, accom.id, preview)}
      page={page}
      pageItem={item}
      data-testid={`accommodation-item-${accom.id}`}
    >
      <LocationItem
        header="Accommodation"
        name={accom.name}
        address={accom.address}
        description={accom.description}
        website={accom.website}
        phone={accom.phone}
        photoPath={photoPath}
        email={accom.email}
        className={className}
        {...dragProps}
      />
    </PageItemLink>
  );
};

export default Accommodation;
